module.exports = __webpack_public_path__ + "static/img/room_title1.fa06fa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/room_title1.png
// module id = HRat
// module chunks = 0